import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, lineHeights, media, radii, space } = theme

export const Section = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: ${space['spacing-xxxl']} 0 0;
  background-color: ${colors['blue-background-strong-default']};

  @media (${media.desktop}) {
    display: flex;
    align-items: center;

    /* 712px no desenho, sobre um frame de 1905px. */
    min-height: min(44.5rem, 37.4vw);
    padding: 6.25rem 0;
  }
`

export const Infos = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['spacing-xl']};

  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    line-height: ${lineHeights['font-line-height-sm']};
    letter-spacing: -0.02em;
  }

  /* O CTA do desenho é ciano com texto azul escuro, em pílula, com rótulo e
     seta juntos no centro — não o space-between com gap de 32px que vem do
     design system. */
  .ds-button {
    justify-content: center;
    gap: ${space['spacing-xs']};
    background-color: ${colors['cyan-background-pressed']};
    border-radius: ${radii['corner-radius-pill']};
    color: ${colors['neutral-text-default']};

    &:hover,
    &:focus-visible {
      background-color: ${colors['cyan-background-strong-default']};
      color: ${colors['neutral-text-default']};
    }
  }

  @media (${media.desktop}) {
    gap: 3.125rem;

    .ds-button {
      /* 491px do desenho. */
      width: 30.6875rem;
    }
  }
`

export const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};

  p {
    margin: 0;
  }
`


const MOBILE_IMAGE_HEIGHT = 'clamp(20.5rem, 52vw, 30rem)'

const MOBILE_FADE_END = '24%'

const MOBILE_IMAGE_ZOOM = 1.2

/* A foto ocupa a direita e se dissolve no azul pela borda esquerda. */
export const ImageWrapper = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
  height: ${MOBILE_IMAGE_HEIGHT};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transform: scale(${MOBILE_IMAGE_ZOOM});
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      ${colors['blue-background-strong-default']} 0%,
      rgb(24 84 255 / 0%) ${MOBILE_FADE_END}
    );
  }

  @media (${media.desktop}) {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 59.5%;
    height: auto;

    img {
      transform: none;
    }

    &::after {
      background: linear-gradient(to right, ${colors['blue-background-strong-default']} 0%, rgb(24 84 255 / 0%) 28%);
    }
  }
`

const LINE_HEIGHT = '10.58vw'

const MOBILE_LINE_WIDTH = 'min(46vw, 18.75rem)'
const MOBILE_LINE_HEIGHT = `calc(${MOBILE_LINE_WIDTH} * 202 / 651)`

const MOBILE_POLYGON_WIDTH = '1.375rem'
const MOBILE_POLYGON_HEIGHT = `calc(${MOBILE_POLYGON_WIDTH} * 56 / 44)`

const POLYGON_OFFSET_FROM_LINE_END = 0.547

export const LineWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: ${MOBILE_LINE_WIDTH};

  img {
    width: 100%;
    height: auto;
  }

  @media (${media.desktop}) {
    right: auto;
    left: 65.9%;
    width: 34.1%;
  }
`

export const PolygonWrapper = styled.div`
  position: absolute;
  right: calc(${MOBILE_LINE_WIDTH} * ${POLYGON_OFFSET_FROM_LINE_END} - ${MOBILE_POLYGON_WIDTH} / 2);
  bottom: calc(${MOBILE_LINE_HEIGHT} - ${MOBILE_POLYGON_HEIGHT} / 2);
  z-index: 2;

  svg {
    width: ${MOBILE_POLYGON_WIDTH};
    height: ${MOBILE_POLYGON_HEIGHT};
  }

  @media (${media.desktop}) {
    right: auto;
    bottom: calc(${LINE_HEIGHT} - 1.75rem);
    left: 80.2%;

    svg {
      width: 2.75rem;
      height: 3.5rem;
    }
  }
`
